import { configureStore, combineReducers } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist-indexeddb-storage';
import { 
  FLUSH, 
  REHYDRATE, 
  PAUSE, 
  PERSIST, 
  PURGE, 
  REGISTER 
} from 'redux-persist';

import workspacesReducer from './workspacesSlice';
import basketReducer from './basketSlice';
import topicsReducer from './topicsSlice';

const persistConfig = {
  key: 'root',
  storage: storage('myAppDB'),
  whitelist: ['workspaces', 'basket', 'topics'], // Specify which reducers to persist
};

const rootReducer = combineReducers({
  workspaces: workspacesReducer,
  basket: basketReducer,
  topics: topicsReducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
      // Disable immutableStateInvariant in development
      immutableCheck: false,
      serializableCheck: false,
    }),
});

export const persistor = persistStore(store);
